import * as XLSX from 'xlsx';

export function exportToCSV(data, filename = "addresses.csv", headers = null) {
  if (!data || !data.length) {
    alert("No addresses selected to export.");
    return;
  }

  const normalizeEntries = (row) => (Array.isArray(row) ? row : Object.values(row || {}));

  const resolvedHeaders = Array.isArray(headers) && headers.length ? [...headers] : [];

  if (!resolvedHeaders.length) {
    const seenHeaders = new Set();

    const addHeader = (header) => {
      if (!header || seenHeaders.has(header)) return;
      seenHeaders.add(header);
      resolvedHeaders.push(header);
    };

    data.forEach(row => {
      normalizeEntries(row).forEach(item => addHeader(item?.key));
    });
  }

  if (!resolvedHeaders.length) {
    console.error("No exportable data found.");
    return;
  }

  const csvRows = [];

  // Header row
  csvRows.push(resolvedHeaders.map(header => `"${String(header).replace(/"/g, '""')}"`).join(","));

  // Data rows
  data.forEach(row => {
    const rowMap = new Map();
    normalizeEntries(row).forEach(item => {
      if (!item?.key || rowMap.has(item.key)) return;
      rowMap.set(item.key, item.value);
    });

    const values = resolvedHeaders.map(header => {
      let val = rowMap.get(header) ?? "";
      val = String(val).replace(/"/g, '""');
      return `"${val}"`;
    });

    csvRows.push(values.join(","));
  });

  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportToExcel(data, filename = "addresses.xlsx", headers = null) {
  if (!data || !data.length) {
    alert("No addresses selected to export.");
    return;
  }

  const firstRow = Object.values(data[0] || {});
  const resolvedHeaders = Array.isArray(headers) && headers.length
    ? [...headers]
    : firstRow.map(item => item?.key).filter(Boolean);

  if (!resolvedHeaders.length) {
    console.error("No exportable data found.");
    return;
  }

  const rows = [resolvedHeaders];

  data.forEach(row => {
    const rowValues = Object.values(row || {});
    const rowMap = new Map();

    rowValues.forEach(item => {
      if (!item?.key || rowMap.has(item.key)) return;
      rowMap.set(item.key, item.value ?? "");
    });

    rows.push(resolvedHeaders.map(header => rowMap.get(header) ?? ""));
  });

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Address Selections");
  XLSX.writeFile(workbook, filename);
}
